export default "__VITE_ASSET__d536fc8b__"